import type { FeatureRoutes } from '@/app/screens'

/* An invited account chooses its password: before any session, outside the shell. */
export default {
  routes: [
    { path: '/invitation', component: () => import('./InvitationPage.vue'), meta: { standalone: true } },
  ],
} satisfies FeatureRoutes
